import { QueryClient } from "@tanstack/react-query";

/**
 * Global QueryClient instance.
 *
 * Created outside of any component to ensure a single instance
 * is shared across the entire app (as recommended by TanStack Query docs).
 *
 * Default options:
 * - retry: false    — no automatic retries on failure (e.g. 401)
 * - staleTime: 60s  — cached data stays fresh for 1 minute
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 1000 * 60,
    },
  },
});
